var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-2",staticStyle:{"display":"flex","flex-direction":"row","flex-wrap":"wrap","align-content":"center","justify-content":"space-between"}},[_c('h5',[_vm._v(_vm._s(_vm.first))]),_c('h5',[_vm._v(_vm._s(_vm.second))])])}
var staticRenderFns = []

export { render, staticRenderFns }